import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useGetEoyReconStatusQuery = (invoiceId?: string, enabled?: boolean) => {
  const { isLoading, isSuccess, data, refetch } = useQuery(
    [API_URL.EOY_PLAN_RECONCILIATIONS_INVOICES_BY_INVOICE_ID, invoiceId, enabled],
    invoiceId ? () => api.get(API_URL.EOY_PLAN_RECONCILIATIONS_INVOICES_BY_INVOICE_ID(invoiceId)) : () => null,
    {
      retry: 0,
      enabled,
    }
  );

  const eoyReturnStatus = useMemo(() => {
    if (!data) return null;
    return data.data?.status;
  }, [data]);

  const eoyReconPlanName = useMemo(() => {
    if (!data) return null;
    return data.data?.plan_name;
  }, []);

  return {
    data: data?.data,
    eoyReturnStatus,
    eoyReconPlanName,
    isLoading,
    isSuccess,
    refetch,
  };
};
